<template>
    <div class="bg-white blog-card p-3 rounded shadow">
        <div class="blog-card-top">
            <a href="###" class="blog-image"><img src="https://sieuthinhuquynh.com/storage/media/gJx1RMumw3E4pH7AKTMJJU0feOFLQwgSfLRvsEfa.png" alt="blog image" class="w-100"></a>



        </div>
        <div class="blog-card-middle">
            <a href="###" class="blog-name multiple-line" style="max-height: 55px;">
                <h5 class="h5 py-2">SALE 8/8 Ngày đặc biệt DEAL đặc biệt SALE UP TO 15%

                </h5>
            </a>
            <ul class="list-inline my-2 posted-info">
                <li class="h6 mb-0"><i class="las la-user-circle" aria-hidden="true"></i><small><em> Như Quỳnh </em></small>
                </li>

                <li class="h6 mb-0"><i class="las la-calendar" aria-hidden="true"></i><small><em>
                            07-08-2020 14:51 </em></small></li>
            </ul>
            <a href="###" class="blog-name multiple-line" style="max-height: 43px;">
                <h6 class="text-dark">8/8 ngày đẹp giá tốt Ngày đặc biệt - Deal đặc biệt - Giảm up to 15% tất cả các mặt hàng - Chỉ duy nhất 1 ngày

                </h6>
            </a>


        </div>
        <div class="blog-card-bottom pt-2 text-center">

            <button class="btn btn-primary btn-add-to-cart"> XEM THÊM </button>
        </div>
    </div>
</template>

<script>
    import ProductRating from './ProductRating.vue';
    import ProductCardMixin from '../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
